import React, { useEffect, useState } from "react";

import { FaChevronDown, FaChevronUp, FaExternalLinkAlt } from "react-icons/fa";

import { Link } from "react-router-dom";

import TutorialContentRenderer from "./TutorialContentRenderer";
import TutorialMediaGallery from "./TutorialMediaGallery";

export default function TutorialStepCard({
  step,
  index,
  forceOpen = false,
  onOpenLightbox,
}) {
  const [expanded, setExpanded] = useState(forceOpen || index === 0);

  useEffect(() => {
    if (forceOpen) {
      setExpanded(true);
    }
  }, [forceOpen]);

  return (
    <article
      id={`tutorial-step-${step.slug}`}
      className="scroll-mt-36 overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm transition hover:border-slate-300 dark:border-slate-800 dark:bg-slate-900 dark:hover:border-slate-700"
    >
      <button
        type="button"
        onClick={() => setExpanded((current) => !current)}
        className="flex w-full items-start gap-4 p-4 text-left sm:p-5"
        aria-expanded={expanded}
      >
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-violet-100 text-sm font-bold text-violet-700 dark:bg-violet-500/15 dark:text-violet-300">
          {index + 1}
        </span>

        <span className="min-w-0 flex-1">
          <span className="block text-base font-semibold leading-6 text-slate-900 dark:text-white sm:text-lg">
            {step.title}
          </span>

          {step.keywords ? (
            <span className="mt-1 block truncate text-xs text-slate-400">
              {step.keywords}
            </span>
          ) : null}
        </span>

        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300">
          {expanded ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </button>

      {expanded ? (
        <div className="border-t border-slate-100 px-4 pb-5 pt-5 dark:border-slate-800 sm:px-5 sm:pb-6">
          <TutorialContentRenderer
            content={step.text}
            format={step.format || "texte"}
          />

          <TutorialMediaGallery
            medias={step.medias || []}
            fallbackImage={step.img}
            fallbackAlt={step.title}
            onOpenLightbox={onOpenLightbox}
          />

          {step.button?.label && step.button?.url ? (
            <div className="mt-6">
              <TutorialActionButton button={step.button} />
            </div>
          ) : null}
        </div>
      ) : null}
    </article>
  );
}

function TutorialActionButton({ button }) {
  const className =
    "inline-flex items-center justify-center gap-2 rounded-2xl bg-violet-600 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-600/20 transition hover:bg-violet-700";

  const isInternal = button.url.startsWith("/") && !button.newTab;

  if (isInternal) {
    return (
      <Link to={button.url} className={className}>
        {button.label}
      </Link>
    );
  }

  return (
    <a
      href={button.url}
      target={button.newTab ? "_blank" : undefined}
      rel={button.newTab ? "noopener noreferrer" : undefined}
      className={className}
    >
      {button.label}

      {button.newTab ? <FaExternalLinkAlt /> : null}
    </a>
  );
}
